<section class="flex-box">
    <ng-container *ngIf="!loading">
        <div *ngFor="let item of items" class="base-info-item" [ngClass]="{'double-col': item.isLongString}">
            <ng-container [ngSwitch]="item.templateName">
                <ng-container *ngSwitchCase="'FlagText'">
                    <ng-container
                        *ngTemplateOutlet="FlagText;
                    context: {$implicit:item,value:data[item.key],enumMap:item.enumMap,colorMap:item.templateParams.colorMap}">
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'DATAPROTECTION'">
                    <ng-container
                        *ngTemplateOutlet="DATAPROTECTION;context:{$implicit:item,value:data[item.key]}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'Link'">
                    <ng-container
                        *ngTemplateOutlet="Link;
                    context: {$implicit:item,value:data[item.key],data:data}">
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'LinkIcon'">
                    <ng-container
                        *ngTemplateOutlet="LinkIcon;
                    context: {$implicit:item,value:data[item.key],data:data}">
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'Time'">
                    <ng-container
                        *ngTemplateOutlet="Time;
                    context: {$implicit:item,value:data[item.key]}">
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'Capacity'">
                    <ng-container
                        *ngTemplateOutlet="Capacity;
                    context: {$implicit:item,value:data[item.key]}">
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <ng-container
                        *ngTemplateOutlet="Base; context: {$implicit:item,value:getValue(data,item.key),enumMap:item.enumMap}">
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="loading">
        <div *ngFor="let item of items" class="base-info-item">
            <span class="title">{{item.title}}</span>
            <app-skeleton [height]="'100%'"></app-skeleton>
        </div>
    </ng-container>
</section>
<ng-template #Base let-enumMap="enumMap" let-item let-value="value">
    <span [ngStyle]="{minWidth:getMinWidth()}" [class]="'title' + (item.title === 'ストレージプールを所有中' ? ' min-width175': '')">{{item.title}}</span>
    <span class="text" nTextTips nTextTipsPlacement="top">{{getEnumMapValue|fn:value:enumMap}}</span>
</ng-template>
<ng-template #FlagText let-colorMap="colorMap" let-enumMap="enumMap" let-item let-value="value">
    <span [ngStyle]="{minWidth:getMinWidth()}" class="title">{{item.title}}</span>
    <span class="text"><span [ngStyle]="{background:colorMap[value]}" class="flag"></span>
        {{getEnumMapValue(value, enumMap)}}
  </span>
</ng-template>
<ng-template #DATAPROTECTION let-item let-value="value">
    <span [ngStyle]="{minWidth:getMinWidth()}" class="title">{{item.title}}</span>
    <div style="display: flex;align-items: center" class="base-info-icon-list">
        <svg *ngIf="value && value.SnapShot === 'TRUE'" [nTooltip]="i18n.get('common.snapshot_title')" nTooltipPlacement="top">
            <use xlink:href="#app-icon-snapshot"></use>
        </svg>
        <svg *ngIf="value && value.LunClone === 'TRUE'" [nTooltip]="i18n.get('common.clone_button')" nTooltipPlacement="top">
            <use xlink:href="#app-icon-clone"></use>
        </svg>
        <svg *ngIf="value && value.HyperCDP === 'TRUE'" [nTooltip]="i18n.get('protection.HyperCDP_title')" nTooltipPlacement="top">
            <use xlink:href="#app-icon-hyperCDP"></use>
        </svg>
        <svg *ngIf="value && value.RemoteReplication === 'TRUE'" [nTooltip]="i18n.get('common.replication_title')" nTooltipPlacement="top">
            <use xlink:href="#app-icon-replication"></use>
        </svg>
        <svg *ngIf="value && value.HyperMetro === 'TRUE'" [nTooltip]="i18n.get('common.HyperMetro_title')" nTooltipPlacement="top">
            <use xlink:href="#app-icon-hypermetro"></use>
        </svg>
        <svg *ngIf="value && value.drStar === 'TRUE'" [nTooltip]="i18n.get('protection.dataProtection_term_drStar_featureName')" nTooltipPlacement="top">
            <use xlink:href="#app-icon-3dc"></use>
        </svg>
    </div>
    <span *ngIf="isEmpty(value)" class="text">{{DEFAULT_VALUE}}</span>
</ng-template>
<ng-template #Link let-data="data" let-item let-value="value">
    <span [ngStyle]="{minWidth:getMinWidth()}" class="title">{{item.title}}</span>
    <span *ngIf="value" (click)="clickListItem(item.templateParams&&item.templateParams.link,data)" class="text link" nTextTips
        nTextTipsPlacement="top">{{value}}</span>
    <span *ngIf="!value" class="text" nTextTips nTextTipsPlacement="top">{{DEFAULT_VALUE}}</span>
</ng-template>
<ng-template #LinkIcon let-data="data" let-item let-value="value">
    <span [ngStyle]="{minWidth:getMinWidth()}" class="title">{{item.title}}</span>
    <div *ngIf="value" class="link-text">
        <span (click)="clickListItem(item.templateParams&&item.templateParams.link,data)" class="text link" nTextTips
            nTextTipsPlacement="top">{{value}}</span>
    </div>
    <span *ngIf="!value" class="text" nTextTips nTextTipsPlacement="top">{{DEFAULT_VALUE}}</span>
</ng-template>
<ng-template #Time let-item let-value="value">
    <span [ngStyle]="{minWidth:getMinWidth()}" class="title">{{item.title}}</span>
    <span *ngIf="value" class="text" nTextTips
        nTextTipsPlacement="top">{{formatTime|fn:value}}</span>
    <span *ngIf="!value" class="text" nTextTips nTextTipsPlacement="top">{{DEFAULT_VALUE}}</span>
</ng-template>
<ng-template #Capacity let-item let-value="value">
    <span [ngStyle]="{minWidth:getMinWidth()}" class="title">{{item.title}}</span>
    <span *ngIf="value" class="text" nTextTips
          nTextTipsPlacement="top">{{value | adaptUnit: 'Sector'}}</span>
    <span *ngIf="!value" class="text" nTextTips nTextTipsPlacement="top">{{DEFAULT_VALUE}}</span>
</ng-template>
